module.exports = __webpack_public_path__ + "img/value-3.1a169666.png";